import './index.scss';
import React from 'react';
import PDFViewer from '~/components/pdf_viewer';
import { useDocumentView } from '../providers';
const DocumentPanel = ({ fileName, pdf }) => {
    const { highlights } = useDocumentView();
    if ((!document || Object.keys(document).length === 0)) {
        return (React.createElement("span", null,
            React.createElement("i", { className: 'fas fa-spin fa-spinner' })));
    }
    return (React.createElement("div", { className: 'document-panel' },
        React.createElement("h2", null, fileName),
        React.createElement(PDFViewer, { document: pdf, highlights: highlights })));
};
export default DocumentPanel;
